import { cloneDeep } from 'lodash';
import { watch, ref, toValue, type Ref } from 'vue';

export function useWatchItemLoading<T>(
  id: Ref<number> | (() => number),
  store: any,
  onItemLoaded?: (item: T) => void,
): Ref<T | null> {
  const item: Ref<T | null> = ref(null);

  watch(
    () => {
      const currentId = toValue(id);
      return [currentId, store.isItemLoading(currentId)] as const;
    },
    ([currentId, isLoading]) => {
      if (isLoading) return;
      item.value = cloneDeep(store.getItem(currentId));
      if (item.value && onItemLoaded) onItemLoaded(item.value);
    },
    { immediate: true },
  );

  return item;
}
